var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('button',{on:{"click":_vm.random}},[_vm._v(" More "),_c('i',{staticClass:"fas fa-arrow-right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }